module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "n-radio radio",
    class: ("radio-" + _vm.type)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    attrs: {
      "id": _vm.cbId,
      "type": "radio",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.model === true,
      "value": _vm.label,
      "checked": _vm._q(_vm.model, _vm.label)
    },
    on: {
      "__c": function($event) {
        _vm.model = _vm.label
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.cbId
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1da86b2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Inputs/Radio.vue
// module id = 505
// module chunks = 55